function formatPhoneNumber(phoneNumberString) {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(48|)?(\d{3})(\d{3})(\d{3})$/);
    if (match) {
        const intlCode = (match[1] ? '+48 ' : '');
        return [intlCode, match[2], ' ', match[3], ' ', match[4]].join('');
    }
    return phoneNumberString;
}
export default formatPhoneNumber